<div class="cases-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%" style="font-size: 9pt">
            <TR>

                <TD style="width: 25%; text-align: left; padding-left: 10px;" > 
                    <label *ngIf="this.showUnLimitedStatusFilter || this.showRestrictedStatusFilter">Show: &nbsp;&nbsp;</label>
                    <dw-dropdown [disabled]="isEditing" *ngIf="this.showUnLimitedStatusFilter || this.showRestrictedStatusFilter"
                            [selectedItem]="selectedViewFilter"
                            (itemSelected)="selectedViewFilter = $event; onChangeViewFilterValue()"
                            [dataSource]="showList"
                            [controlWidth]="'180px'"
                            matTooltip="Choose from pre-selected lists">
                    </dw-dropdown>

                </TD>
                <TD align="left" style="min-width: 300px; width: 35%;text-align: center; ">
                    <input text id="txtFilter" #txtFilter
                           class="qs_filter-field" [disabled]="this.isEditing" [(ngModel)]="strFilterText"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>"
                           matTooltip = "Type to match data in all columns except date fields">
                    <button mat-button matSuffix mat-icon-button [disabled]="isEditing"
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon style="scale: 80%;">close</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Refresh the grid" aria-label="Refresh"
                            (click)="txtFilter.value=''; refreshButtonClickHandler();">
                        <mat-icon style="scale: 80%;">refresh</mat-icon>
                    </button>

                    <button mat-button class="command-button" [disabled]="isEditing" *ngIf="visibleGlobalSearch"
                            matTooltipPosition="below"
                            style="margin-top: 5px; width:100px;"
                            matTooltip="Query the system for case and member records" (click)="doGlobalSearch()"
                            mat-button>
                        <mat-icon>search</mat-icon>
                        Search
                    </button>

                </TD>
                <TD  style="text-align: center">
                        <button mat-button class="command-button"
                        	*ngIf="visibleAddNewCase"
                            matTooltipPosition="right"
                            style="width:120px; color:white; background-color:
                            var(--buttonBlue)"
                            matTooltip="Add a new case"
                            (click)="doAddNewCase()">
                        <mat-icon style="scale: 80%;">add_circle_outline</mat-icon>Add Case
                    </button>


                  <TD class="table-pagination-cell" align="right" style="font-size:10pt;" >{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
    </div>

        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div #tb1 [ngClass]="contentClassName" id="casesTableId" class="mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                 <ng-container matColumnDef="id" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="true"
                        class="mat-table-header-style table-header-class"> Id </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class" [hidden]="true"> {{element.id}}
                    </td>
				  </ng-container>

                  <ng-container matColumnDef="memberId" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="false"
                            class="mat-table-header-style table-header-class"> Id </th>
                        <td mat-cell *matCellDef="let element" class="table-row-class"
                            [hidden]="false">
                            {{element.memberId}}
                        </td>
                  </ng-container>

                  <ng-container matColumnDef="duplicateStatus" >
				    <th  mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style table-header-class" style="vertical-align: bottom;width: 30px">
				    	<mat-icon>outlined_flag</mat-icon>
				    </th>
				    <td  mat-cell *matCellDef="let element" class="table-row-class"
                        style="width: 30px">
				    	<a style="cursor: pointer;"(click)="openDuplicatesDialog(element)">
                            <img class="duplicate-flag" *ngIf="element.duplicateStatus==='D'" src="assets/duplicate.png" matTooltip = "This record is possibly duplicated"/></a>
				    	    <img class="duplicate-flag" *ngIf="element.duplicateStatus==='R'" src="assets/duplicate-resolved.png" matTooltip = "The duplication has been resolved"/>
				   	</td>
				  </ng-container>

				  <ng-container matColumnDef="fullName">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style table-header-class"> Member Name </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class">
                        {{element.fullName}} </td>
				  </ng-container>

                  <!-- Relationship Type -->
                  <ng-container matColumnDef="relationship" >
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Relationship </th>
                      <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.relationship}} </td>
                  </ng-container>

				  <!-- Date of Birth -->
				  <ng-container matColumnDef="dateOfBirth">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style table-header-class"
                        style="display: table-cell; padding-left: 20px;"
                    >Date of Birth</th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"
                    style="padding-left: 20px;"
                    >{{lblShowDate(element.dateOfBirth) }}</td>
				  </ng-container>

                    <!-- Gender -->
				  <ng-container matColumnDef="gender" >
				    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="mat-table-header-style table-header-class"> Gender </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.gender}} </td>
				  </ng-container>

                    <!-- case number -->
                    <ng-container matColumnDef="caseNumber" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            class="mat-table-header-style table-header-class case-text-color" style="padding-left: 5px;"> Case Number
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-row-class case-text-color"
                            style="padding-left: 5px;">
                            {{element.caseNumber}} </td>
                    </ng-container>

                    <ng-container matColumnDef="caseId" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="false"
                            class="mat-table-header-style table-header-class case-text-color"> Case Id </th>
                        <td mat-cell *matCellDef="let element" class="table-row-class case-text-color"
                            [hidden]="false">
                            {{element.caseId}}
                        </td>
                    </ng-container>

                    <!-- applicant -->
                    <ng-container matColumnDef="applicant">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            class="mat-table-header-style table-header-class case-text-color"> Case Applicant </th>
                        <td mat-cell *matCellDef="let element" class="table-row-class case-text-color">
                            {{element.applicant}}
                        </td>
                    </ng-container>

                    <!-- case status -->
                   <ng-container matColumnDef="caseStatus">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class case-text-color"> Status
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class case-text-color">{{element.caseStatus}} </td>
				  </ng-container>

				    <!-- Date added -->
				  <ng-container matColumnDef="dateAdded">
				    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="mat-table-header-style table-header-class case-text-color"> Date
                        Created </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class case-text-color">
                        {{lblShowDate(element.dateCreated) }} </td>
				  </ng-container>

                    <!-- dateClosed -->
                    <ng-container matColumnDef="dateClosed">
                        <th mat-header-cell *matHeaderCellDef  mat-sort-header class="mat-table-header-style table-header-class case-text-color"> Date
                            Closed </th>
                        <td mat-cell *matCellDef="let element" class="table-row-class case-text-color">
                            <span *ngIf="element.caseStatus !== 'Open'">{{lblShowDate(element.dateClosed) }}</span>
                        </td>
                   </ng-container>

                    <!-- Details Control -->
				   <ng-container matColumnDef="btnDetails" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header  class="mat-table-header-style table-header-class">
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> 
				    	<mat-icon *ngIf="showCaseDetails" aria-hidden="false" class="command-icon-style" (click)="onRowDoubleClicked(element)"
                                  style="cursor:
				    pointer;"  tabindex="-1" [matTooltip]="'Click to view details'">assignment
				    	</mat-icon>
				    </td>
				  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row
                      *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                      [ngClass]="{'row-selected': tableRowIdx == Idx}"
                      (click)="onRowClicked(row)"  (dblclick)="onRowDoubleClicked(row)">
                  </tr>
                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
        </div>
</div>

<p-dialog header="Global Search - Cases" [focusOnShow]="false"
          [(visible)]="displaySearchDlg" [modal]="true"
          [style]="{width: '1130px', height: '775px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-globalsearch-cases #globalSearch
                      (submitClicked)="globalSearchSelect($event)"
                      (cancelClicked)="displaySearchDlg=false">
    </app-globalsearch-cases>
</p-dialog>

<p-dialog header="Add New Case" [focusOnShow]="false"
          [(visible)]="displayAddCaseDlg" [modal]="true"
          [style]="{width: '965px', height: '790px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="false" >
    <app-add-new-case #addNewCase
        (submitClickedEvent)="doAddCaseSubmitted($event)"
        (cancelClickedEvent)="displayAddCaseDlg=false">
    </app-add-new-case>
</p-dialog>
<p-dialog *ngIf="displayCaseDetailsDlg" header="Case Details" [focusOnShow]="true"
          [(visible)]="displayCaseDetailsDlg" [modal]="true"
          [style]="{ 'width': '1300px', 'height': '780px', 'min-width': '1300px',
          'min-height': '780px','overflow':'auto'  }"
          appendTo="body"
          [minY]="45" [resizable]="false" [closable]="false">
    <app-case-details-dialog
        [selectedId]="selectedRecord?.caseId">
    </app-case-details-dialog>
     <ng-template pTemplate="footer">
            <div style="text-align: center;">
			<button mat-button class="command-button" [disabled]="isCaseDetailIsEditing"
			                           (click)="doClose()" matTooltip="Close window"
					  mat-button>
				  <mat-icon>cancel</mat-icon>
				  Close
			  </button>
		</div>
        </ng-template>
</p-dialog>
<p-dialog [header]="strDuplicatesHeader" [focusOnShow]="false"
          [(visible)]="visibleDuplicateDlg" [modal]="true"
           [style]="{ 'width': '1200px', 'height': '718px', 'min-width': '1200px', 'min-height': '718px' }"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-duplicate-members-dlg #duplicatemember
                    (cancelClicked)="visibleDuplicateDlg=false"
                    (submitClicked)="onDuplicateResolved($event)">
    </app-duplicate-members-dlg>
</p-dialog>
